export default "__VITE_ASSET__Bw0v$0yi__"